import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=b6309d40&scoped=true&"
import script from "@/views/Groups/Tabs/Audit.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Audit.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/audit.scss?vue&type=style&index=0&id=b6309d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6309d40",
  null
  
)

export default component.exports